var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13537",
    "data-name": "Group 13537",
    transform: "translate(-0.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2296",
    "data-name": "Rectangle 2296",
    transform: "translate(0.235 0)",
    fill: "#fff",
    stroke: "#21827f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Video_upload",
    "data-name": "Video upload",
    transform: "translate(16.235 64.394)",
    fill: "#21827f",
    fontSize: 10,
    fontFamily: "Tajawal-Light, Tajawal",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Video upload")), /*#__PURE__*/React.createElement("path", {
    id: "film-solid",
    d: "M0,36.632A4.637,4.637,0,0,1,4.632,32H32.426a4.637,4.637,0,0,1,4.632,4.632V59.794a4.637,4.637,0,0,1-4.632,4.632H4.632A4.637,4.637,0,0,1,0,59.794ZM3.474,56.32v2.316a1.162,1.162,0,0,0,1.158,1.158H6.949a1.162,1.162,0,0,0,1.158-1.158V56.32a1.161,1.161,0,0,0-1.158-1.158H4.632A1.161,1.161,0,0,0,3.474,56.32ZM30.11,55.162a1.161,1.161,0,0,0-1.158,1.158v2.316a1.162,1.162,0,0,0,1.158,1.158h2.316a1.162,1.162,0,0,0,1.158-1.158V56.32a1.161,1.161,0,0,0-1.158-1.158ZM3.474,47.055v2.316a1.162,1.162,0,0,0,1.158,1.158H6.949a1.162,1.162,0,0,0,1.158-1.158V47.055A1.161,1.161,0,0,0,6.949,45.9H4.632A1.161,1.161,0,0,0,3.474,47.055ZM30.11,45.9a1.161,1.161,0,0,0-1.158,1.158v2.316a1.162,1.162,0,0,0,1.158,1.158h2.316a1.162,1.162,0,0,0,1.158-1.158V47.055A1.161,1.161,0,0,0,32.426,45.9ZM3.474,37.79v2.316a1.162,1.162,0,0,0,1.158,1.158H6.949a1.162,1.162,0,0,0,1.158-1.158V37.79a1.161,1.161,0,0,0-1.158-1.158H4.632A1.161,1.161,0,0,0,3.474,37.79ZM30.11,36.632a1.161,1.161,0,0,0-1.158,1.158v2.316a1.162,1.162,0,0,0,1.158,1.158h2.316a1.162,1.162,0,0,0,1.158-1.158V37.79a1.161,1.161,0,0,0-1.158-1.158ZM11.581,38.949v4.632A2.314,2.314,0,0,0,13.9,45.9h9.265a2.314,2.314,0,0,0,2.316-2.316V38.949a2.314,2.314,0,0,0-2.316-2.316H13.9A2.314,2.314,0,0,0,11.581,38.949ZM13.9,50.529a2.314,2.314,0,0,0-2.316,2.316v4.632A2.314,2.314,0,0,0,13.9,59.794h9.265a2.314,2.314,0,0,0,2.316-2.316V52.846a2.314,2.314,0,0,0-2.316-2.316Z",
    transform: "translate(24.235 -17.176)",
    fill: "#21827f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/video-upload.a45e27583f82b8b8e80c8cd4c99bd522.svg";
export { ForwardRef as ReactComponent };